import * as React from 'react';
import {Alert} from 'antd';
import {ErrorResponse} from '../api/dtos/dtos';

import './ErrorAlert.css';
import locales from '../locales';


interface ErrorAlertProps {
  error?: ErrorResponse;
  style?: React.CSSProperties;
}

export class ErrorAlert extends React.Component<ErrorAlertProps, object> {

  public render() {
    const {style, error} = this.props;
    return (
      <div style={style}>
        {error && (
          <Alert
            type="error"
            showIcon={true}
            style={{overflow: 'auto'}}
            message={error.message}
            description={error.details &&
                <table className="error-alert-table">
                    <tbody>
                    <tr>
                        <td style={{verticalAlign: 'top'}}><b>{locales.url}:</b></td>
                        <td>{error.details.path}</td>
                    </tr>
                    <tr>
                        <td style={{verticalAlign: 'top'}}><b>{locales.message}:</b></td>
                        <td>{error.details.message}</td>
                    </tr>
                    </tbody>
                </table>
            }
          />
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/ErrorAlert.tsx